import { Component, OnInit } from '@angular/core';
import { TableElementComponent } from '@uranda/ui';

@Component({
  selector: 'app-table-avatar',
  templateUrl: './table-avatar.component.html',
  styleUrls: ['./table-avatar.component.css'],
  standalone: false
})
export class TableAvatarComponent extends TableElementComponent implements OnInit {
  coverUrl: string = '';
  representative: string = '';
  name: string = '';
  partnerData: any;
  bold = false;
  deletionScheduledAt: string | null = null;

  override ngOnInit(): void {

    if (this.data.partner) {
      this.partnerData = this.data.partner;
    } else {
      this.partnerData = this.data;
      const representativeName = this.partnerData.representativeFirstName;
      const representativeLast = this.partnerData.representativeLastName;
      this.bold = representativeName !== undefined && representativeLast !== undefined;
      this.representative = this.bold ? representativeName + ' ' + representativeLast : '';
    }

    this.coverUrl = this.partnerData.coverUrl || this.partnerData.partnerCoverImage || '/assets/avatar_placeholder.png';
    this.name = this.partnerData.name || this.partnerData.partnerName || 'Unassigned';
    if (this.props?.showDeletionBadge && this.partnerData.status === 'PENDING_DELETION') {
      this.deletionScheduledAt = this.partnerData.deletionScheduledAt ?? null;
    }
  }


}
